import { TimeAssistantAttachment } from '../entity/TimeAssistantAttachment';
import { Base } from '../dto/Base';
import { Pagination } from 'pansx-utils';
import { RemoveEmptyUtils } from 'pansx-utils';
import { Page } from 'pansx-utils';

export class TimeAssistantAttachmentDto {
    public static url = '/timeAssistantAttachment';

    public static async findById(id: number): Promise<TimeAssistantAttachment> {
        const response = await Base.getDataWithJwt(this.url + '/byId', { id });
        const timeAssistantAttachment = response as TimeAssistantAttachment;
        return timeAssistantAttachment;
    }

    public static async findAll(
        timeAssistantAttachment: TimeAssistantAttachment
    ): Promise<TimeAssistantAttachment[]> {
        RemoveEmptyUtils.removeEmptyString(timeAssistantAttachment);
        RemoveEmptyUtils.removeZero(timeAssistantAttachment);
        const response = await Base.getDataWithJwt<TimeAssistantAttachment[]>(
            this.url + '/all',
            timeAssistantAttachment
        );
        const timeAssistantAttachmentList =
            response as TimeAssistantAttachment[];
        return timeAssistantAttachmentList;
    }

    public static async allPage(
        timeAssistantAttachment: TimeAssistantAttachment,
        pagination: Pagination
    ): Promise<Page<TimeAssistantAttachment>> {
        RemoveEmptyUtils.removeEmptyString(timeAssistantAttachment);
        RemoveEmptyUtils.removeZero(timeAssistantAttachment);
        const response = await Base.findAllPageWithToken(
            this.url + '/allPage',
            pagination,
            timeAssistantAttachment
        );
        return response as Page<TimeAssistantAttachment>;
    }

    public static async delete(id: number) {
        await Base.getDataWithJwt(this.url + '/delete', { id });
    }

    public static async save(
        timeAssistantAttachment: TimeAssistantAttachment
    ): Promise<TimeAssistantAttachment> {
        const response = await Base.postWithToken(
            this.url + '/save',
            timeAssistantAttachment
        );
        return response as TimeAssistantAttachment;
    }
}
